import { Box, Container, HStack, Tab, TabList, TabPanel, TabPanels, Tabs, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AppContext } from '../comments/AppContext'
import { CourseTableFrame } from './CourseTableFrame'
import { ProviderTableFrame } from './ProviderTableFrame'
import { AuthService } from '../services/AuthService'
import { ErrorMessage } from '../components/ErrorMessage'
import { ExpertTableFrame } from './ExpertTableFrame'
import { AppBreadcrumb } from '../navbar/AppBreadcrumb';
import { AppLinkBar } from '../navbar/AppLinkBar'

export const DashboardPage = () => {

  const { isAuthenticated } = React.useContext(AppContext);
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();

  const availableTabs = React.useMemo(() => {
    const tabs: { key: string; label: string }[] = [];
    if (isAuthenticated) tabs.push({ key: 'courses', label: 'Courses' });
    if (AuthService.isStaff) tabs.push({ key: 'providers', label: 'Providers' });
    if (AuthService.isStaff) tabs.push({ key: 'experts', label: 'Experts' });
    return tabs;
  }, [isAuthenticated]);

  const handleTabChange = (index: number) => navigate(`/${availableTabs[index].key}`);

  const breadcrumb = React.useMemo(() => [
    { label: 'Home', href: '/' },
    ...(tab ? [{ label: availableTabs.find(t => t.key === tab)?.label || '', href: `/${tab}` }] : []),
  ], [isAuthenticated, AuthService.isStaff, tab, availableTabs]);

  const [errorMessage, setErrorMessage] = React.useState<any>();
  const height = useBreakpointValue({ base: undefined, lg: 'calc(100vh - 250px)' });

  React.useEffect(() => {
    if (isAuthenticated === false) {
      setErrorMessage({ name: 'AuthError' });
    }
  }, [isAuthenticated]);

  return <>
    <AppBreadcrumb breadcrumb={breadcrumb} />
    <AppLinkBar />
    <Container mt={100} py={{ base: 4 }} px={{ base: 1, md: 8 }}>
      <ErrorMessage error={errorMessage} />
    </Container>
    <Tabs index={availableTabs.findIndex(x => x.key === tab)} isLazy onChange={handleTabChange}>
      <Container>
        <HStack justifyContent='space-between' alignItems='center'>
          <TabList px={{ base: 0, md: 4 }}>
            {availableTabs.map(tab => (
              <Tab key={tab.key}>{tab.label}</Tab>
            ))}
          </TabList>
          <Box id='eitum-toolbar' />
        </HStack>
      </Container>
      <TabPanels minH={height}>
        {availableTabs.map(tab => {
          switch (tab.key) {
            case 'courses':
              return (
                <TabPanel key='courses' px='0'>
                  <CourseTableFrame
                    errorMessage={errorMessage} setErrorMessage={setErrorMessage}
                  />
                </TabPanel>
              );
            case 'providers':
              return (
                <TabPanel key='providers' px='0'>
                  <ProviderTableFrame
                    errorMessage={errorMessage} setErrorMessage={setErrorMessage}
                  />
                </TabPanel>
              );
            case 'experts':
              return (
                <TabPanel key='experts' px='0'>
                  <ExpertTableFrame
                    errorMessage={errorMessage} setErrorMessage={setErrorMessage}
                  />
                </TabPanel>
              );
            default:
              return null;
          }
        })}
      </TabPanels>
    </Tabs>
  </>
}